/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Auth_Sso_Login_ErrorInputs */



/**
* | output |
* | --- |
* | "Failed to log in with {provider}. Please try again." |
*
* @param {Auth_Sso_Login_ErrorInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_sso_login_error = /** @type {((inputs: Auth_Sso_Login_ErrorInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Sso_Login_ErrorInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Anmeldung mit ${i?.provider} fehlgeschlagen. Bitte versuche es erneut.`)
	return /** @type {LocalizedString} */ (`Failed to log in with ${i?.provider}. Please try again.`)
});